import fetchWithTimeout from './fetchAPI';

export async function getNotifications(token) {
    const headers = new Headers();
    headers.append('token', token);
    const path = 'notification';
    const results = await fetchWithTimeout(path,
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);

    const jsonResults = await results.json();
    return (jsonResults);
}

export async function updateNotification(token, notification) {
  const headers = new Headers();
  headers.append('token', token);
  headers.append('Content-Type', 'application/json');
  const results = await fetchWithTimeout('readnotification',
      {method: 'POST',
          headers: headers,
          body: JSON.stringify(notification),
          cache: 'no-cache',
          redirect: 'follow',
          credentials: 'omit'
      }, 3000);
  const jsonResults = await results.json();
  return (jsonResults);
}